import React from "react";
import Slick from "react-slick";
import PuntosDelMes from "./PuntosDelMes";

import "./styles.css";

const constants = {
//  MONTH_NUMS: [1,2,3,4,5,6,7,8,9,10,11,12],
  INV_MONTH_NUMS: [12,11,10,9,8,7,6,5,4,3,2,1],
  MONTHS: ['-','Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre']
}

function getPeriodTitle(period) {
  return constants.MONTHS[parseInt(period.toString().substr(4,2), 10)] + 
         ' - ' + 
         period.toString().substr(0,4);      
}

function getPeriodList(props) {
  var aux2 = [];
  
  var aux1 = props.goals.map(goal => {return (goal.period !== null ? goal.period.toString() : 0)});
  for (var i = 0; i < aux1.length; i++) {
    if (aux1[i]) {
      if (aux2.indexOf(aux1[i]) === -1) {
        aux2.push(aux1[i]);
      }
    }
  }
  var aux3 = props.points.map(point => {return (point.period !== null ? point.period.toString() : 0)});
  for (var j = 0; j < aux3.length; j++) {
    if (aux3[j]) {
      if (aux2.indexOf(aux3[j]) === -1) {
        aux2.push(aux3[j]);
      }
    }
  }
  aux2.sort();
  
  var periodList = [];
  for (var k = aux2.length - 1; k >= 0; k--) {
    periodList.push(aux2[k]);
  }
  
  return periodList;
}

const Render = (props) => {
  var periodList = getPeriodList(props);

  const settings = {
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1
  };

  return (
    ((props.goals && props.goals.length) || (props.points && props.points.length)) && (
      <div className="container mb-70 historialPuntos">
        <h1 key="historialTit" className="avenirBK fullWidth blue linea mt-70">Historial de puntos</h1>
        <Slick
          {...settings}
          className="historialMeses horizontal clearfix mask pbl"
        >
          {periodList.map(period => (
            <li key={("slide"+period)} >
              <div>
                <PuntosDelMes key={("PuntosDelMes"+period)} id={period} 
                              periodo={getPeriodTitle(period)} 
                              period={period} 
                              user={props.user} 
                              mes={constants.MONTHS[parseInt(period.toString().substr(4,2), 10)]} 
                              goals={props.goals.filter(goal => {return goal.period === parseInt(period, 10);})}
                              points={props.points.filter(point => {return point.period === parseInt(period, 10);})} 
                />
              </div>
            </li>
          ))}
        </Slick>
      </div>
    )
  );
};

Render.contextTypes = {};

export default Render;



// WEBPACK FOOTER //
// ./src/pages/Home/HistorialDePuntos.js